export enum PreferencesSettingsKeyEnum {
  gmapsTheme = 'preferences-gmaps-theme',
  markerSize = 'preferences-marker-size',
  refreshSpeed = 'preferences-refresh-speed',
  pathType = 'preferences-path-type',
  reportType = 'preferences-report-type',
  speedAndColor = 'preferences-speed-and-color',
  blackboxInfoWindow = 'preferences-blackbox-info-window', // Active id fields (model property from BBX?PRF=INFOBULLE)
  materialsInfoWindow = 'preferences-materials-info-window',
  companyPresets = 'company-presets',
  defaultZoom = 'preferences-zoom',
  reportDialogType = 'preferences-report-dialog-type',
  isClustered = 'preferences-map-options-clustered',
  typeControl = 'preferences-map-options-control',
  isTrafficShown = 'preferences-map-options-traffic',
}
